import React, {Suspense} from 'react'
import {Navigate, Outlet, RouteObject} from 'react-router'

import {GuardedRoutes} from './GuardedRoutes'
import {
  PageForbidden,
  PageNotFound,
  PageSkeleton,
  PagePlantSelect
} from './modules/common/components'
import {PagePlant} from './modules/common/components/PagePlant'
import {GlobalProvider} from './modules/common/providers'
import {DefaultPageRedirect} from './modules/common/redirects/DefaultPageRedirect'
import {SuiteHierarchyRedirect} from './modules/common/redirects/SuiteHierarchyRedirect'
import {getRelPath, ROUTES} from './modules/routing'
import {LoginGuard} from './modules/routing/components/LoginGuard'

export const AppRoutes: RouteObject[] = [
  {
    path: getRelPath(ROUTES.BASE.path),
    element: (
      <Suspense fallback={<PageSkeleton />}>
        <GlobalProvider>
          <Outlet />
        </GlobalProvider>
      </Suspense>
    ),
    children: [
      {
        element: <LoginGuard />,
        children: [
          {
            path: ROUTES.BASE.SUITE_REDIRECT.path,
            element: <SuiteHierarchyRedirect />
          },
          {
            path: getRelPath(ROUTES.BASE.PLANT_SELECTOR.path),
            children: [
              {
                index: true,
                element: <PagePlantSelect />
              },
              {
                path: getRelPath(ROUTES.BASE.PLANT_SELECTOR.PLANT.path),
                element: <PagePlant />,
                children: [
                  {
                    index: true,
                    element: <DefaultPageRedirect />
                  },
                  {
                    path: '*',
                    children: [...GuardedRoutes]
                  }
                ]
              }
            ]
          },
          {
            path: '',
            element: <PagePlantSelect />
          },
          {
            path: '*',
            element: <Navigate to={ROUTES.BASE.NOT_FOUND.path} replace />
          }
        ]
      },
      {
        path: getRelPath(ROUTES.BASE.NOT_FOUND.path),
        element: <PageNotFound />
      },
      {
        path: getRelPath(ROUTES.BASE.NOT_AUTHORIZED.path),
        element: <PageForbidden />
      }
    ]
  }
]
